import type { Locale } from '../i18n/resources';

const WEEKDAYS_ZH = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
const WEEKDAYS_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Format a Date or ISO string as a short date + weekday + time, in local time.
 *   zh: "4月28日 周三 19:00"
 *   en: "Wed, Apr 28 19:00"
 *
 * Returns '-' for null/undefined/invalid input.
 */
export function formatDateTime(input: Date | string | null | undefined, locale: Locale): string {
  if (!input) return '-';
  const d = typeof input === 'string' ? new Date(input) : input;
  if (isNaN(d.getTime())) return '-';

  const hour = String(d.getHours()).padStart(2, '0');
  const minute = String(d.getMinutes()).padStart(2, '0');

  if (locale === 'en') {
    return `${WEEKDAYS_EN[d.getDay()]}, ${MONTHS_EN[d.getMonth()]} ${d.getDate()} ${hour}:${minute}`;
  }
  return `${d.getMonth() + 1}月${d.getDate()}日 ${WEEKDAYS_ZH[d.getDay()]} ${hour}:${minute}`;
}

/**
 * Format a Date or ISO string to Chinese-friendly format.
 * e.g. "4月28日 周三 19:00"
 *
 * Returns '-' for null/undefined/invalid input.
 */
export function formatDateZh(input: Date | string | null | undefined): string {
  return formatDateTime(input, 'zh');
}
